import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, FlutterIcon, HealthcareIcon, ReactIcon} from "../../../app-constants";
import {Link} from 'gatsby';


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: 'Unlock the full potential of the Android platform with TekRevol\'s Android app development services in Los Angeles. Our expert team designs and develops custom Android apps tailored to your business needs, ensuring seamless performance and a user-friendly interface. From concept to launch, we provide end-to-end solutions, leveraging the latest technologies to create apps that stand out in the Google Play Store.',
    },
    {
        icon: IphoneIcon,
        title: 'iPhone app development',
        description: (
            <>
                Experience the iOS pinnacle with TekRevol's{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development services
                </Link> {' '}
                in Los Angeles. Our skilled app developers in Los Angeles bring your vision to life with user-friendly, visually captivating apps that cater to the Apple ecosystem. We meticulously craft iPhone apps, optimizing them for speed and performance to ensure a delightful user experience.
            </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: 'TekRevol\'s game app development services redefine entertainment. Our creative game developers craft immersive and engaging gaming experiences across various platforms. From concept ideation to design, development, and testing, we turn your gaming ideas into reality, making your game a standout in the competitive gaming market.',
    },
    {
        icon: FlutterIcon,
        title: 'Flutter app development',
        description: 'TekRevol is your trusted partner for Flutter app development. We utilize the power of Google\'s Flutter framework to build cross-platform apps that work seamlessly on both Android and iOS. Our expert team ensures your app is high-performing, visually appealing, and rich in features, reaching a wider audience effectively.',
    },
    {
        icon: HealthcareIcon,
        title: 'Healthcare app development',
        description: 'In the ever-evolving healthcare landscape, TekRevol\'s healthcare app development services provide innovative solutions. We design and develop healthcare apps that enhance patient care, streamline processes, and improve communication between healthcare providers and patients. Our expertise ensures compliance, data security, and a user-friendly experience.',
    },
    {
        icon: ReactIcon,
        title: 'React Native app development',
        description: 'Discover the efficiency of cross-platform development with TekRevol\'s React Native app development services. Our skilled team leverages the power of React Native to create cost-effective, high-quality apps for both Android and iOS. We ensure a consistent user experience across platforms while maximizing development speed and cost-effectiveness.',
    },
];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol’s Mobile App Development Services in Los Angeles</h2>
                        <p>At TekRevol, we specialize in crafting cutting-edge mobile apps. Our services encompass custom app design, development, and optimization, delivering user-centric solutions that drive engagement and business growth.</p>
                        <p className="impro_para">Here's a quick overview of TekRevol's mobile app development services in Los Angeles</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;